import {TrackableEntity} from './data/ChangeTrackable';
import { IDictionary } from './data/TrackingModule';
import { DBMappingInfo } from '../framework.core/data/DBMappingInfo';
import _ from 'lodash';

export class CustomizeReport extends TrackableEntity {
    id: number = 0;
    tbName: string = '';
    name: string = '';
    description1: string = '';
    description2: string = '';
    description3: string = '';
    description4: string = '';
    description5: string = '';
    description6: string = '';
    querySub1: string = '';
    querySub2: string = '';
    query: string = '';
    orderBy: string = '';
    type1: number = 0;
    type2: number = 0;
    type3: number = 0;
    type4: number = 0;
    type5: number = 0;
    type6: number = 0;
    u2Date: string | null = null;
    u2ID: string = '';
    u1Date: string | null = null;
    u1ID: string = '';
    
    constructor(init?:Partial<CustomizeReport>) {
        super();
        this.key='id';
        Object.assign(this, init);
        this.noTrackProps.push('id');
        if(this.id === 0) this.id = this.GetNextId();
    }

    getDbMappings(arg?:any):IDictionary<DBMappingInfo> {
        const dicFieldMap:IDictionary<DBMappingInfo> = {};
        _.keys(CustomizeReport.dicFieldMappings).forEach(m=>{
            dicFieldMap[m] = CustomizeReport.dicFieldMappings[m];
        });

        return dicFieldMap;
    }

    static dicFieldMappings:IDictionary<DBMappingInfo> = {
        'id': new DBMappingInfo({ field: 'F_ID', table: 'T_AOTHERINFO' }),
        'tbName': new DBMappingInfo({ field: 'F_TbName', table: 'T_AOTHERINFO' }),
        'name': new DBMappingInfo({ field: 'F_C1', table: 'T_AOTHERINFO' }),
        'description1': new DBMappingInfo({ field: 'F_C2', table: 'T_AOTHERINFO' }),
        'description2': new DBMappingInfo({ field: 'F_C3', table: 'T_AOTHERINFO' }),
        'description3': new DBMappingInfo({ field: 'F_C4', table: 'T_AOTHERINFO' }),
        'description4': new DBMappingInfo({ field: 'F_C5', table: 'T_AOTHERINFO' }),
        'description5': new DBMappingInfo({ field: 'F_C7', table: 'T_AOTHERINFO' }),
        'description6': new DBMappingInfo({ field: 'F_C8', table: 'T_AOTHERINFO' }),
        'querySub1': new DBMappingInfo({ field: 'F_C6', table: 'T_AOTHERINFO' }),
        'querySub2': new DBMappingInfo({ field: 'F_C10', table: 'T_AOTHERINFO' }),
        'orderBy': new DBMappingInfo({ field: 'F_C9', table: 'T_AOTHERINFO' }),
        'type1': new DBMappingInfo({ field: 'F_N2', table: 'T_AOTHERINFO' }),
        'type2': new DBMappingInfo({ field: 'F_N3', table: 'T_AOTHERINFO' }),
        'type3': new DBMappingInfo({ field: 'F_N4', table: 'T_AOTHERINFO' }),
        'type4': new DBMappingInfo({ field: 'F_N5', table: 'T_AOTHERINFO' }),
        'type5': new DBMappingInfo({ field: 'F_N7', table: 'T_AOTHERINFO' }),
        'type6': new DBMappingInfo({ field: 'F_N8', table: 'T_AOTHERINFO' }),
        'u1ID': new DBMappingInfo({ field: 'F_U1ID', table: 'T_AOTHERINFO' }),
        'u1Date': new DBMappingInfo({ field: 'F_U1Date', table: 'T_AOTHERINFO' }),
        'u2ID': new DBMappingInfo({ field: 'F_U2ID', table: 'T_AOTHERINFO' }),
        'u2Date': new DBMappingInfo({ field: 'F_U2Date', table: 'T_AOTHERINFO' }),
    };
}
